module.exports = __webpack_public_path__ + "c4a01108634e87b98f9750302ffce5d8.svg";